<div>
    
<ppl-accordion [title]="'File Upload'" [isOpen]="true" *authorize="[pageId, tabId, 'FileUpload', 'section']">
    <ppl-file-upload [filedInfo]="filedInfo" [sectionData]="steps" [entry]="entry" (filesUpdated)="filesUpdated()" [readonly]="readonly"></ppl-file-upload>
  </ppl-accordion>
</div>